import { render } from "./ReportSalesWeb.vue?vue&type=template&id=0d631e04&scoped=true"
import script from "./ReportSalesWeb.vue?vue&type=script&lang=js"
export * from "./ReportSalesWeb.vue?vue&type=script&lang=js"

import "./ReportSalesWeb.vue?vue&type=style&index=0&id=0d631e04&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d631e04"]])

export default __exports__